import http from "../../core/services/http.service";

const ReleaseNotesService = {
  getReleaseNotesList() {
    return http.get('/api/v1/release-notes/');
  },
  getReleaseNote(uuid) {
    return http.get(`/api/v1/release-notes/${uuid}/?expand=body`);
  },

};

export default ReleaseNotesService;
